import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../Api/Api";
 

// PrivateRoute Component
const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />; // Redirect to login if not authenticated
};

export default PrivateRoute;
